<template>
  <!-- <div> -->
  <v-container>
    <v-row>
      <v-col class="pa-0" xs="12" md="12">
        <v-card class="mx-auto px-2" outlined>
          <v-row>
            <v-col xs="12" md="6">
              <div class="px-2 primary--text font-weight-bold">
                {{ $vuetify.lang.t("$vuetify.tab.maira_profiles_tab") }}
              </div>
            </v-col>
            <v-col xs="12" md="6">
              <template>
                <v-btn
                  class="float-right"
                  color="primary"
                  :disabled="!$hasProjectAccessFor([$pRole.ADMIN])"
                  @click="onCreateClick"
                >
                  {{$vuetify.lang.t('$vuetify.gpt_profile.create_profile')}}
                  <v-icon right class="ml-2">add_circle_outline</v-icon>
                </v-btn>
              </template>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row>
            <!-- <v-col cols="12" xs="12" md="4">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                :label="$vuetify.lang.t('$vuetify.common.search_btn_txt')"
                outlined
                dense
                single-line
                hide-details
              ></v-text-field>
            </v-col> -->
          </v-row>
          <v-divider></v-divider>
          <Loader v-if="isLoading" class="mr-2 mt-6" />
          <v-data-table
            v-else
            :headers="headers"
            :items="gptProfiles.profiles"
            :search="search"
            :page.sync="page"
            :items-per-page="itemsPerPage"
            hide-default-footer
          >
            <template v-slot:[`item.id`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">
                    {{item.id.split("-")[0]}}
                  </span>
                </template>
                <span>{{ item.id }}</span>
              </v-tooltip>
            </template>
            <template v-slot:[`item.name`]="{ item }">
              <div>
                <v-btn
                  text
                  class="primary--text text--darken-3"
                  @click="onDetailsClick(item)"
                >{{ item.name }}</v-btn>
              </div>
            </template>
            <template v-slot:[`item.created_at`]="{ item }">
              {{
                item.created_at
                  ? new Date(item.created_at).toLocaleDateString("en-us", {
                    year: "numeric",
                    month: "short",
                    day: "numeric",
                  })
                  : "N/A"
              }}
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <ButtonGroup
                :disabledEditButton="!$hasProjectAccessFor([$pRole.ADMIN])"
                :disabledDeleteButton="!$hasProjectAccessFor([$pRole.ADMIN])"
                :disabledDuplicateButton="!$hasProjectAccessFor([$pRole.ADMIN])"
                :groupType="ACTION_BUTTON_GROUP"
                :addButton="false"
                :stopButton="false"
                :startButton="false"
                :duplicateButton="true"
                @onDeleteClick="deleteItem(item)"
                @onEditClick="onEditClick(item)"
                @onDetailsClick="onDetailsClick(item)"
                @onDuplicateClick="onDuplicateClick(item)"
              />
            </template>
          </v-data-table>
          <v-row>
            <v-col class="py-0" cols="12" md="12">
              <v-divider></v-divider>
            </v-col>
            <v-col cols="12" xs="12" sm="3" md="3"></v-col>
            <v-col cols="12" xs="12" sm="6" md="6">
              <v-pagination
                class="text-center"
                v-model="page"
                :length="pageCount"
              ></v-pagination>
            </v-col>
            <v-col cols="12" offset-sm="1" offset-md="1" xs="3" sm="2" md="2">
              <v-select
                v-model="itemsPerPage"
                :items="rows"
                hide-details="auto"
                outlined
                dense
              ></v-select>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <DialogModal
      v-model="deleteDialog"
      :title="$vuetify.lang.t('$vuetify.common.confirm_alert_title_txt')"
      :message="$vuetify.lang.t('$vuetify.common.confirm_alert_msg_txt_6')"
      :confirmButtonText="$vuetify.lang.t('$vuetify.common.confirm_btn')"
      :cancelButtonText="$vuetify.lang.t('$vuetify.common.cancel_btn')"
      @onConfirmation="deleteProfile()"
      @onCancel="deleteDialog = false"
    />
    <!-- create profile -->
    <v-dialog
      persistent
      v-model="openCreateProfileModal"
      content-class="gpt-profile-dialog"
    >
      <v-card class="d-flex flex-column">
        <Loader v-if="(profileEdit && profileLoading) || isDuplicateLoading" class="mr-2 mt-6" />
        <v-container v-else>
          <v-row>
            <v-card-title class="font-weight-bold">
              {{ profileEdit ? $vuetify.lang.t('$vuetify.gpt_profile.update_profile') : $vuetify.lang.t('$vuetify.gpt_profile.create_profile') }}
            </v-card-title>
          </v-row>
          <v-divider></v-divider>
          <v-row>
            <v-col>
              <CreateGptProfile
                ref="profile"
                :key="profileKey"
                @liff-enabled-changed="handleLiffEnabled"
                @profile-tags-change="onProfileTagsChange"
                @group-invitations-updated="onGroupInvitationsUpdated"
                @model-status-changed="onModelStatusChanged"
              />
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row class="gpt-profile-actions-row">
            <v-col>
              <v-card-actions class="justify-end">
                <v-btn
                  color="error"
                  outlined
                  @click="closeProfileModal()"
                >
                  {{$vuetify.lang.t('$vuetify.common.close_btn')}}
                </v-btn>
                <v-btn
                  color="primary"
                  outlined
                  @click="profileEdit ? updateProfile() : createProfile()"
                  :loading="isLoading"
                  :disabled="isLoading || modelDetailsStatus === 'loading'"
                >
                  {{ profileEdit ? $vuetify.lang.t('$vuetify.common.update_btn') : $vuetify.lang.t('$vuetify.common.create') }}
                  <v-progress-circular v-if="isLoading" indeterminate color="white"></v-progress-circular>
                </v-btn>
              </v-card-actions>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
    <!-- view profile -->
    <v-dialog
      persistent
      v-model="openProfileViewModal"
      content-class="gpt-profile-dialog"
    >
      <v-card outlined class="d-flex flex-column">
        <Loader v-if="viewProfile && profileLoading" class="mr-2 mt-6" />
        <v-container v-else>
          <v-row>
            <v-card-title class="font-weight-bold">
              {{ $vuetify.lang.t("$vuetify.gpt_profile.profile_information") }}
            </v-card-title>
          </v-row>
          <v-divider></v-divider>
          <v-list>
            <v-list-item>
              <v-list-item-content class="font-weight-bold">
                ID
              </v-list-item-content>
              <v-list-item-content class="d-flex justify-space-between align-center">
                <span>
                  {{ selectedGptProfile.id }}
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        small
                        v-bind="attrs"
                        v-on="on"
                        @click="copyToClipboard(selectedGptProfile.id)"
                        class="hover-blue"
                      >
                        <v-icon>mdi-content-copy</v-icon>
                      </v-btn>
                    </template>
                    <span>Copy</span>
                  </v-tooltip>
                </span>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content class="font-weight-bold">
                {{ $vuetify.lang.t("$vuetify.table_header.name_header_txt") }}
              </v-list-item-content>
              <v-list-item-content>
                {{ selectedGptProfile.profileName }}
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content class="font-weight-bold">
                {{ $vuetify.lang.t("$vuetify.gpt_profile.introduction") }}
              </v-list-item-content>
              <v-list-item-content>
                {{ selectedGptProfile.intro }}
              </v-list-item-content>
            </v-list-item>
            <v-list-item class="responsive-list-panel">
              <v-list-item-content class="font-weight-bold">
                {{ $vuetify.lang.t("$vuetify.gpt_history.gpt_history_system") }}
              </v-list-item-content>
              <v-list-item-content>
                {{ selectedGptProfile.system }}
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content class="font-weight-bold">
                {{ $vuetify.lang.t("$vuetify.gpt_profile.instructions") }}
              </v-list-item-content>
              <v-list-item-content>
                {{ selectedGptProfile.instructions || 'N/A' }}
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content class="font-weight-bold">
                {{ $vuetify.lang.t("$vuetify.gpt_history.gpt_history_model") }}
              </v-list-item-content>
              <v-list-item-content>
                {{ selectedGptProfile.model }}
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content class="font-weight-bold">
                {{ $vuetify.lang.t("$vuetify.gpt_history.gpt_history_provider") }}
              </v-list-item-content>
              <v-list-item-content>
                {{ profile.provider }}
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content class="font-weight-bold">
                {{ $vuetify.lang.t("$vuetify.gpt_profile.tools") }}
              </v-list-item-content>
              <v-list-item-content>
                <template v-if="selectedGptProfile?.tools?.length">
                  <div class="chips-container">
                    <v-chip
                      v-for="(item, index) in formatTools(selectedGptProfile.tools)"
                      :key="`tool-${index}`"
                      class="chips-content"
                      small
                    >
                      {{ item }}
                    </v-chip>
                  </div>
                </template>
                <template v-else>
                  N/A
                </template>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content class="font-weight-bold">
                {{ $vuetify.lang.t("$vuetify.gpt_history.gpt_history_temperature") }}
              </v-list-item-content>
              <v-list-item-content>
                {{ selectedGptProfile.temperature }}
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content class="font-weight-bold">
                {{ $vuetify.lang.t("$vuetify.gpt_profile.top_p") }}
              </v-list-item-content>
              <v-list-item-content>
                {{ selectedGptProfile.top_p }}
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content class="font-weight-bold">
                {{ $vuetify.lang.t("$vuetify.gpt_profile.top_k") }}
              </v-list-item-content>
              <v-list-item-content>
                {{ selectedGptProfile.top_k }}
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content class="font-weight-bold">
                {{ $vuetify.lang.t("$vuetify.gpt_profile.search_max_token") }}
              </v-list-item-content>
              <v-list-item-content>
                {{ selectedGptProfile.searchMaxToken}}
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content class="font-weight-bold">
                {{ $vuetify.lang.t("$vuetify.gpt_history.gpt_history_completion_tokens") }}
              </v-list-item-content>
              <v-list-item-content>
                {{ selectedGptProfile.completionToken }}
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content class="font-weight-bold">
                {{ $vuetify.lang.t("$vuetify.gpt_history.gpt_history_frequency_penalty") }}
              </v-list-item-content>
              <v-list-item-content>
                {{ selectedGptProfile.frequencyPenalty }}
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content class="font-weight-bold">
                {{ $vuetify.lang.t("$vuetify.gpt_history.gpt_history_presence_penalty") }}
              </v-list-item-content>
              <v-list-item-content>
                {{ selectedGptProfile.presencePenalty }}
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content class="font-weight-bold">
                {{ $vuetify.lang.t("$vuetify.gpt_profile.stop") }}
              </v-list-item-content>
              <v-list-item-content>
                <template v-if="selectedGptProfile?.stop?.length">
                  <div class="chips-container">
                    <v-chip
                      v-for="(item, index) in getChipItems(selectedGptProfile?.stop)"
                      :key="`stop-${index}`"
                      class="chips-content"
                      small
                    >
                      {{ item }}
                    </v-chip>
                  </div>
                </template>
                <template v-else>
                  N/A
                </template>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content class="font-weight-bold">
                {{ $vuetify.lang.t("$vuetify.access_tab.access_tags") }}
              </v-list-item-content>
              <v-list-item-content>
                <template v-if="selectedGptProfile?.access_tags?.length">
                  <div class="chips-container">
                    <v-chip
                      v-for="(item, index) in getChipItems(selectedGptProfile?.access_tags)"
                      :key="`access-tag-${index}`"
                      class="chips-content"
                      small
                    >
                      {{ item }}
                    </v-chip>
                  </div>
                </template>
                <template v-else>
                  N/A
                </template>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content class="font-weight-bold">
                {{ $vuetify.lang.t("$vuetify.gpt_profile.dataset_tags") }}
              </v-list-item-content>
              <v-list-item-content>
                <template v-if="(!selectedGptProfile?.datasetTags || (!selectedGptProfile?.datasetTags?.includes?.length && !selectedGptProfile?.datasetTags?.excludes?.length))">
                  N/A
                </template>
                <template v-else>
                  <div v-if="selectedGptProfile?.datasetTags?.includes?.length">
                    <div class="chips-container">
                      <div class="mt-1">include:</div>
                      <v-chip
                        v-for="(item, index) in getChipItems(selectedGptProfile?.datasetTags?.includes)"
                        :key="`dataset-include-${index}`"
                        class="chips-content"
                        small
                      >
                        {{ item }}
                      </v-chip>
                    </div>
                  </div>
                  <div v-if="selectedGptProfile?.datasetTags?.excludes?.length">
                    <div class="chips-container">
                      <div class="mt-1">exclude:</div>
                      <v-chip
                        v-for="(item, index) in getChipItems(selectedGptProfile?.datasetTags?.excludes)"
                        :key="`dataset-exclude-${index}`"
                        class="chips-content"
                        small
                      >
                        {{ item }}
                      </v-chip>
                    </div>
                  </div>
                </template>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content class="font-weight-bold">
                {{ $vuetify.lang.t("$vuetify.gpt_history.gpt_history_auto_evaluation") }}
              </v-list-item-content>
              <v-list-item-content>
                {{ selectedGptProfile.is_auto_evaluation }}
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content class="font-weight-bold">
                {{ $vuetify.lang.t("$vuetify.gpt_profile.is_citation_enabled") }}
              </v-list-item-content>
              <v-list-item-content>
                {{ selectedGptProfile.is_citation_enabled ?? 'N/A' }}
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content class="font-weight-bold">
                {{ $vuetify.lang.t("$vuetify.gpt_profile.search_mode") }}
              </v-list-item-content>
              <v-list-item-content>
                {{ filteredSearchMode }}
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content class="font-weight-bold">
                {{ $vuetify.lang.t("$vuetify.gpt_history.gpt_history_personalizer_only") }}
              </v-list-item-content>
              <v-list-item-content>
                {{ selectedGptProfile.is_personalizer_only }}
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content class="font-weight-bold">
                {{ $vuetify.lang.t("$vuetify.gpt_history.gpt_history_chat_history_length") }}
              </v-list-item-content>
              <v-list-item-content>
                {{ selectedGptProfile.chat_history_length }}
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content class="font-weight-bold">
                {{ $vuetify.lang.t("$vuetify.gpt_history.gpt_history_intro_token") }}
              </v-list-item-content>
              <v-list-item-content>
                {{ selectedGptProfile.introToken }}
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content class="font-weight-bold">
                {{ $vuetify.lang.t("$vuetify.gpt_history.gpt_history_system_token") }}
              </v-list-item-content>
              <v-list-item-content>
                {{ selectedGptProfile.systemToken }}
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="isJsonSupported">
              <v-list-item-content class="font-weight-bold">
                {{ $vuetify.lang.t("$vuetify.gpt_history.gpt_history_response_format") }}
              </v-list-item-content>
              <v-list-item-content>
                {{ selectedGptProfile.responseFormat }}
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
                <v-list-item-content class="font-weight-bold">
                  {{ $vuetify.lang.t("$vuetify.gpt_profile.dataset_languages") }}
                </v-list-item-content>
                <v-list-item-content>
                  <template v-if="selectedGptProfile?.dataset_languages?.length">
                    <div class="chips-container">
                      <v-chip
                        v-for="(item, index) in formatLanguages(selectedGptProfile?.dataset_languages)"
                        :key="`dataset-language-${index}`"
                        class="chips-content"
                        small
                      >
                        {{ item }}
                      </v-chip>
                    </div>
                  </template>
                  <template v-else>
                    N/A
                  </template>
                </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content class="font-weight-bold">
                {{ $vuetify.lang.t("$vuetify.gpt_profile.is_lang_auto_detect") }}
              </v-list-item-content>
              <v-list-item-content>
                {{ selectedGptProfile.is_lang_auto_detect != null ? selectedGptProfile.is_lang_auto_detect : 'N/A' }}
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
                <v-list-item-content class="font-weight-bold">
                  {{ $vuetify.lang.t("$vuetify.gpt_profile.office_hour_start") }} ({{ $vuetify.lang.t("$vuetify.gpt_profile.hour_format") }})
                </v-list-item-content>
                <v-list-item-content>
                  {{ selectedGptProfile.office_hour_start ? selectedGptProfile.office_hour_start : 'N/A' }}
                </v-list-item-content>
            </v-list-item>
            <v-list-item>
                <v-list-item-content class="font-weight-bold">
                  {{ $vuetify.lang.t("$vuetify.gpt_profile.office_hour_end") }} ({{ $vuetify.lang.t("$vuetify.gpt_profile.hour_format") }})
                </v-list-item-content>
                <v-list-item-content>
                  {{ selectedGptProfile.office_hour_end ? selectedGptProfile.office_hour_end : 'N/A' }}
                </v-list-item-content>
            </v-list-item>
            <v-list-item>
                <v-list-item-content class="font-weight-bold">
                  {{ $vuetify.lang.t("$vuetify.gpt_profile.out_of_office_message") }}
                </v-list-item-content>
                <v-list-item-content>
                  {{ selectedGptProfile.out_of_office_message ? selectedGptProfile.out_of_office_message : 'N/A' }}
                </v-list-item-content>
            </v-list-item>
            <v-list-item>
                <v-list-item-content class="font-weight-bold">
                  {{ $vuetify.lang.t("$vuetify.gpt_profile.max_concurrent_sessions") }}
                </v-list-item-content>
                <v-list-item-content>
                  {{ selectedGptProfile.max_concurrent_sessions ? selectedGptProfile.max_concurrent_sessions : 'N/A' }}
                </v-list-item-content>
            </v-list-item>
            <v-list-item>
                <v-list-item-content class="font-weight-bold">
                  {{ $vuetify.lang.t("$vuetify.gpt_profile.session_limit_reached_message") }}
                </v-list-item-content>
                <v-list-item-content>
                  {{ selectedGptProfile.session_limit_reached_message ? selectedGptProfile.session_limit_reached_message : 'N/A' }}
                </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content class="font-weight-bold">
                {{ $vuetify.lang.t("$vuetify.gpt_profile.session_already_finished_message") }}
              </v-list-item-content>
              <v-list-item-content>
                {{ selectedGptProfile.session_already_finished_message ? selectedGptProfile.session_already_finished_message : 'N/A' }}
              </v-list-item-content>
          </v-list-item>
            <v-list-item>
                <v-list-item-content class="font-weight-bold">
                  {{ $vuetify.lang.t("$vuetify.gpt_profile.session_timeout_minutes") }}
                </v-list-item-content>
                <v-list-item-content>
                  {{ selectedGptProfile.session_timeout_minutes ? selectedGptProfile.session_timeout_minutes : 'N/A' }}
                </v-list-item-content>
            </v-list-item>
            <v-list-item class="responsive-list-panel">
              <v-list-item-content class="font-weight-bold">
                  {{ $vuetify.lang.t("$vuetify.gpt_profile.liff_endpoint_url") }}
              </v-list-item-content>
              <v-list-item-content>
                <span>
                {{ liffEndpointURL }}
                <v-tooltip bottom v-if="selectedGptProfile?.liff_endpoint_url">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      small
                      v-bind="attrs"
                      v-on="on"
                      @click="copyToClipboard(liffEndpointURL)"
                      class="hover-blue"
                    >
                      <v-icon>mdi-content-copy</v-icon>
                    </v-btn>
                  </template>
                  <span>
                    {{ $vuetify.lang.t('$vuetify.common.copy_msg_txt') }}
                  </span>
                </v-tooltip>
              </span>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content class="font-weight-bold">
                {{ $vuetify.lang.t("$vuetify.gpt_history.gpt_history_is_conversation_adding") }}
              </v-list-item-content>
              <v-list-item-content>
                {{ selectedGptProfile?.isConversationAdding }}
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content class="font-weight-bold">
                {{ $vuetify.lang.t("$vuetify.gpt_history.gpt_history_is_background_ask") }}
              </v-list-item-content>
              <v-list-item-content>
                {{ selectedGptProfile?.isBackgroundAsk }}
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content class="font-weight-bold">
                {{ $vuetify.lang.t("$vuetify.gpt_profile.session_close_trigger_config_txt") }}
              </v-list-item-content>
              <v-list-item-content>
                {{ selectedGptProfile.session_close_trigger_config?.is_enabled }}
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="selectedGptProfile.session_close_trigger_config?.is_enabled && selectedGptProfile.session_close_trigger_config?.triggers">
              <v-list-item-content class="font-weight-bold">
                {{ $vuetify.lang.t("$vuetify.gpt_profile.session_close_triggers_txt") }}
              </v-list-item-content>
              <v-list-item-content>
                <div v-if="selectedGptProfile?.session_close_trigger_config?.triggers.length" class="chips-container">
                  <v-chip
                    class="chips-content"
                    v-for="(text, idx) in getChipItems(selectedGptProfile?.session_close_trigger_config?.triggers)"
                    :key="`close-trigger-${idx}`"
                    small
                  >
                    {{ text }}
                  </v-chip>
                </div>
                <span v-else>N/A</span>
              </v-list-item-content>
            </v-list-item>
            <template v-if="isVisionSupported">
              <v-list-item>
                <v-list-item-content class="font-weight-bold">
                  {{ $vuetify.lang.t("$vuetify.gpt_history.gpt_history_vision_settings") }}:
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content class="font-weight-bold pl-4">
                  {{ $vuetify.lang.t("$vuetify.gpt_history.gpt_history_resolution") }}
                </v-list-item-content>
                <v-list-item-content>
                 {{ selectedGptProfile.visionSettings?.resolution }}
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content class="font-weight-bold pl-4">
                  {{ $vuetify.lang.t("$vuetify.gpt_history.gpt_history_image_context_enabled") }}
                </v-list-item-content>
                <v-list-item-content>
                  {{ selectedGptProfile.visionSettings?.imageContextEnabled }}
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content class="font-weight-bold pl-4">
                  {{ $vuetify.lang.t("$vuetify.gpt_history.gpt_history_is_conversation_learning") }}
                </v-list-item-content>
                <v-list-item-content>
                  {{ selectedGptProfile.visionSettings?.isConversationLearning }}
                </v-list-item-content>
              </v-list-item>
            </template>
            <v-row v-if="hasTimeSeriesConfig">
              <v-col>
                <h3 class="subtitle-1 font-weight-bold mb-2 pl-4">
                  {{ $vuetify.lang.t('$vuetify.gpt_profile.time_series_config.title') }}
                </h3>

                <v-list dense class="mb-3 pa-0">
                  <v-list-item class="pa-0">
                    <v-list-item-content class="font-weight-bold pl-8">
                      {{ $vuetify.lang.t('$vuetify.gpt_profile.time_series_config.require_user_confirmation_label') }}:
                    </v-list-item-content>
                    <v-list-item-content class="align-end pr-8">
                      {{ selectedGptProfile.time_series_config?.require_user_confirmation ? 'true' : 'false' }}
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item class="pa-0">
                    <v-list-item-content class="font-weight-bold pl-8">
                      {{ $vuetify.lang.t('$vuetify.gpt_profile.time_series_config.show_reference_fields_label') }}:
                    </v-list-item-content>
                    <v-list-item-content class="align-end pr-8">
                      {{ selectedGptProfile.time_series_config?.show_reference_fields ? 'true' : 'false' }}
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item class="pa-0">
                    <v-list-item-content class="font-weight-bold pl-8">
                      {{ $vuetify.lang.t('$vuetify.gpt_profile.time_series_config.default_timezone_label') }}:
                    </v-list-item-content>
                    <v-list-item-content class="align-end pr-8">
                      {{ defaultTimezoneLabel }}
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-col>
            </v-row>

            <v-row v-if="selectedGptProfile.questionnaire_config && selectedGptProfile.questionnaire_config.length">
              <v-col>
                <h3 class="subtitle-1 font-weight-bold mb-2 pl-4">
                  {{ $vuetify.lang.t('$vuetify.profile.questionnaire_config_header_txt') }}
                </h3>
                <v-expansion-panels accordion class="pl-8 responsive-list-panel">
                  <v-expansion-panel
                    v-for="(config, index) in selectedGptProfile.questionnaire_config"
                    :key="index"
                  >
                    <v-expansion-panel-header>
                      {{ $vuetify.lang.t("$vuetify.maira_questionnaire.questionnaire_name") }}:
                      <span class="font-weight-bold">
                        {{ getQuestionnaireName(config.questionnaire_id) || `Config ${index + 1}` }}
                      </span>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-list dense>
                        <v-list-item>
                          <v-list-item-content class="font-weight-bold">{{ $vuetify.lang.t("$vuetify.maira_questionnaire.display_rule") }}:</v-list-item-content>
                          <v-list-item-content>
                            {{ config.display_rule ? removeUnderScore(config.display_rule) : 'N/A' }}
                          </v-list-item-content>
                        </v-list-item>

                        <v-list-item>
                          <v-list-item-content class="font-weight-bold">{{ $vuetify.lang.t("$vuetify.maira_questionnaire.frequency_settings") }}:</v-list-item-content>
                          <v-list-item-content>
                            <template v-if="config.frequency && typeof config.frequency === 'object' && Object.keys(config.frequency).length > 0">
                              <div v-for="(value, key) in config.frequency" :key="key">
                                {{ getFrequencyLabel(key) }}: {{ value }}
                              </div>
                            </template>
                            <template v-else>
                              N/A
                            </template>
                          </v-list-item-content>
                        </v-list-item>

                        <v-list-item>
                          <v-list-item-content class="font-weight-bold">{{ $vuetify.lang.t("$vuetify.maira_questionnaire.triggers") }}:</v-list-item-content>
                          <v-list-item-content>
                            <template v-if="Array.isArray(config.triggers) && config.triggers.length">
                              <div class="chips-container">
                                <v-chip
                                  v-for="(item, index) in getChipItems(config?.triggers, removeUnderScore)"
                                  :key="`questionnaire-trigger-${index}`"
                                  class="chips-content"
                                  small
                                >
                                  {{ item }}
                                </v-chip>
                              </div>
                            </template>
                            <template v-else>
                              N/A
                            </template>
                          </v-list-item-content>
                        </v-list-item>

                        <v-list-item>
                          <v-list-item-content class="font-weight-bold">{{ $vuetify.lang.t("$vuetify.maira_questionnaire.order") }}:</v-list-item-content>
                          <v-list-item-content>
                            {{ config.order !== undefined && config.order !== null ? config.order : 'N/A' }}
                          </v-list-item-content>
                        </v-list-item>

                        <v-list-item>
                          <v-list-item-content class="font-weight-bold">{{ $vuetify.lang.t("$vuetify.maira_questionnaire.keywords") }}:</v-list-item-content>
                          <v-list-item-content>
                            <template v-if="Array.isArray(config.keywords) && config.keywords.length">
                              <div class="chips-container">
                                <v-chip
                                  v-for="(item, index) in getChipItems(config?.keywords)"
                                  :key="`questionnaire-keyword-${index}`"
                                  class="chips-content"
                                  small
                                >
                                  {{ item }}
                                </v-chip>
                              </div>
                            </template>
                            <template v-else>
                              N/A
                            </template>
                          </v-list-item-content>
                        </v-list-item>

                        <v-list-item>
                          <v-list-item-content class="font-weight-bold">{{ $vuetify.lang.t("$vuetify.maira_questionnaire.use_intelligent_detection") }}:</v-list-item-content>
                          <v-list-item-content>
                            {{ config.use_intelligent_detection !== undefined ? config.use_intelligent_detection : 'N/A' }}
                          </v-list-item-content>
                        </v-list-item>

                        <v-list-item>
                          <v-list-item-content class="font-weight-bold">{{ $vuetify.lang.t("$vuetify.maira_questionnaire.active") }}:</v-list-item-content>
                          <v-list-item-content>
                            {{ config.active !== undefined ? config.active : 'N/A' }}
                          </v-list-item-content>
                        </v-list-item>

                        <v-list-item>
                          <v-list-item-content class="font-weight-bold">{{ $vuetify.lang.t("$vuetify.maira_questionnaire.introduction_message") }}:</v-list-item-content>
                          <v-list-item-content>
                            {{ config.intro_message ? config.intro_message : 'N/A' }}
                          </v-list-item-content>
                        </v-list-item>

                        <v-list-item>
                          <v-list-item-content class="font-weight-bold">{{ $vuetify.lang.t("$vuetify.maira_questionnaire.completion_message") }}:</v-list-item-content>
                          <v-list-item-content>
                            {{ config.completion_message ? config.completion_message : 'N/A' }}
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
            </v-row>

            <v-row v-if="profile?.content_moderation && (profile.content_moderation.is_filtering_enabled || (selectedGptProfile.content_moderation?.categories?.length))">
              <v-col>
                <h3 class="subtitle-1 font-weight-bold mb-2 pl-4">
                  {{ $vuetify.lang.t('$vuetify.gpt_profile.content_moderation.title') }}
                </h3>

                <v-list dense class="mb-3 pa-0">
                  <v-list-item class="pa-0">
                    <v-list-item-content class="font-weight-bold pl-8">
                      {{ $vuetify.lang.t('$vuetify.gpt_profile.content_moderation.filtering_enabled') }}:
                    </v-list-item-content>
                    <v-list-item-content class="align-end pr-8">
                      {{ profile?.content_moderation?.is_filtering_enabled ? 'true' : 'false' }}
                    </v-list-item-content>
                  </v-list-item>
                </v-list>

                <v-row class="pl-8">
                  <v-col cols="12">
                    <v-expansion-panels accordion class="responsive-list-panel">
                      <v-expansion-panel
                        v-for="(cat, idx) in (selectedGptProfile.content_moderation?.categories && selectedGptProfile.content_moderation.categories.length ? selectedGptProfile.content_moderation.categories : [{ name: '', keywords: [], detection_rules: [], severity_actions: { low: 'no_action', medium: 'no_action', high: 'no_action' } }])"
                        :key="'mod_'+(cat._tmpId || cat.name || idx)"
                      >
                        <v-expansion-panel-header class="font-weight-bold" style="font-size: 16px;">
                          {{ cat.name || `${$vuetify.lang.t('$vuetify.gpt_profile.content_moderation.category_label') || 'Category'} ${idx + 1}` }}
                        </v-expansion-panel-header>

                        <v-expansion-panel-content>
                          <v-list dense>
                            <v-list-item>
                              <v-list-item-content class="font-weight-bold">
                                {{ $vuetify.lang.t('$vuetify.gpt_profile.content_moderation.keywords_label') }}:
                              </v-list-item-content>
                              <v-list-item-content>
                                <template v-if="Array.isArray(cat.keywords) && cat.keywords.length">
                                  <div class="chips-container">
                                    <v-chip
                                      v-for="(item, index) in getChipItems(cat?.keywords)"
                                      :key="`moderation-keyword-${idx}-${index}`"
                                      class="chips-content"
                                      small
                                    >
                                      {{ item }}
                                    </v-chip>
                                  </div>
                                </template>
                                <template v-else>N/A</template>
                              </v-list-item-content>
                            </v-list-item>

                            <v-list-item>
                              <v-list-item-content class="font-weight-bold">
                                {{ $vuetify.lang.t('$vuetify.gpt_profile.content_moderation.detection_rules_label') }}:
                              </v-list-item-content>
                              <v-list-item-content>
                                <template v-if="Array.isArray(cat.detection_rules) && cat.detection_rules.length">
                                  <div v-for="(r, i) in cat.detection_rules" :key="i">
                                    {{ i + 1 }}. {{ r }}
                                  </div>
                                </template>
                                <template v-else>
                                  N/A
                                </template>
                              </v-list-item-content>
                            </v-list-item>

                            <v-list-item>
                              <v-list-item-content class="font-weight-bold">
                                {{ $vuetify.lang.t('$vuetify.gpt_profile.content_moderation.severity_actions_title') }}:
                              </v-list-item-content>
                            </v-list-item>

                            <v-list-item
                              v-for="line in formatSeverityActions(cat.severity_actions)"
                              :key="line.label"
                            >
                              <v-list-item-content class="font-weight-bold pl-4">
                                {{ getSeverityLabel(line.label) }}
                              </v-list-item-content>

                              <v-list-item-content>
                                {{ line.value }}
                              </v-list-item-content>
                            </v-list-item>

                            <v-list-item v-if="cat.termination_message">
                              <v-list-item-content class="font-weight-bold">
                                {{ $vuetify.lang.t('$vuetify.gpt_profile.content_moderation.termination_message_label') }}:
                              </v-list-item-content>
                              <v-list-item-content style="white-space: pre-line;">
                                {{ cat.termination_message }}
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <v-row v-if="validExternalConfigs.length">
              <v-col>
                <h3 class="subtitle-1 font-weight-bold mb-2 pl-4">
                  {{ $vuetify.lang.t('$vuetify.gpt_profile.external_system_config.title') }}
                </h3>

                <v-expansion-panels accordion class="pl-8 responsive-list-panel">
                  <v-expansion-panel
                    v-for="(cfg, idx) in validExternalConfigs"
                    :key="'ext_'+(cfg._tmpId || cfg.name || idx)"
                  >
                    <v-expansion-panel-header class="font-weight-bold" style="font-size: 16px;">
                      {{ cfg.name || `${$vuetify.lang.t('$vuetify.gpt_profile.external_system_config.external_config_name') || 'External Config'} ${idx + 1}` }}
                    </v-expansion-panel-header>

                    <v-expansion-panel-content>
                      <v-list dense>
                        <v-list-item>
                          <v-list-item-content class="font-weight-bold">
                            {{ $vuetify.lang.t('$vuetify.gpt_profile.external_system_config.redirection_url_label') }}:
                          </v-list-item-content>
                          <v-list-item-content>
                            <template v-if="cfg.redirection_url">
                              <a :href="cfg.redirection_url" target="_blank" rel="noopener">{{ cfg.redirection_url }}</a>
                            </template>
                            <template v-else>N/A</template>
                          </v-list-item-content>
                        </v-list-item>

                        <v-list-item>
                          <v-list-item-content class="font-weight-bold">
                            {{ $vuetify.lang.t('$vuetify.gpt_profile.external_system_config.redirection_message_label') }}:
                          </v-list-item-content>
                          <v-list-item-content style="white-space: pre-line;">
                            {{ cfg.redirection_message ? cfg.redirection_message : 'N/A'}}
                          </v-list-item-content>
                        </v-list-item>

                        <v-list-item>
                          <v-list-item-content class="font-weight-bold">
                            {{ $vuetify.lang.t('$vuetify.gpt_profile.external_system_config.redirection_delay_label') }}:
                          </v-list-item-content>
                          <v-list-item-content>
                            {{ (cfg.redirection_delay_seconds !== undefined && cfg.redirection_delay_seconds !== null) ? cfg.redirection_delay_seconds : 5 }}
                          </v-list-item-content>
                        </v-list-item>

                        <v-list-item>
                          <v-list-item-content class="font-weight-bold">
                            {{ $vuetify.lang.t('$vuetify.gpt_profile.external_system_config.auto_redirect_label') }}:
                          </v-list-item-content>
                          <v-list-item-content>
                            {{ cfg.auto_redirect === true ? 'true' : (cfg.auto_redirect === false ? 'false' : 'false') }}
                          </v-list-item-content>
                        </v-list-item>

                        <v-list-item>
                          <v-list-item-content class="font-weight-bold">
                            {{ $vuetify.lang.t('$vuetify.gpt_profile.external_system_config.shareable_info_label') }}:
                          </v-list-item-content>
                          <v-list-item-content>
                            <template v-if="Array.isArray(cfg.shareable_info) && cfg.shareable_info.length">
                              <div class="chips-container">
                                <v-chip
                                  v-for="(item, index) in getChipItems(cfg?.shareable_info)"
                                  :key="`shareable-info-${idx}-${index}`"
                                  class="chips-content"
                                  small
                                >
                                  {{ item }}
                                </v-chip>
                              </div>
                            </template>
                            <template v-else>
                              N/A
                            </template>
                          </v-list-item-content>
                        </v-list-item>

                        <v-list-item>
                          <v-list-item-content class="font-weight-bold">
                            {{ $vuetify.lang.t('$vuetify.gpt_profile.external_system_config.redirect_triggering_categories_label') }}:
                          </v-list-item-content>
                          <v-list-item-content>
                            <template v-if="Array.isArray(cfg.redirect_triggering_categories) && cfg.redirect_triggering_categories.length">
                              <div class="chips-container">
                                <v-chip
                                  v-for="(item, index) in getChipItems(cfg?.redirect_triggering_categories)"
                                  :key="`redirect-trigger-${idx}-${index}`"
                                  class="chips-content"
                                  small
                                >
                                  {{ item }}
                                </v-chip>
                              </div>
                            </template>
                            <template v-else>
                              N/A
                            </template>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
            </v-row>

            <v-row v-if="selectedGptProfile?.response_filters && selectedGptProfile.response_filters.length">
              <v-col>
                <h3 class="subtitle-1 font-weight-bold mb-2 pl-4">
                  {{ $vuetify.lang.t('$vuetify.gpt_profile.response_filters.title') }}
                </h3>
                <v-expansion-panels accordion class="pl-8 responsive-list-panel">
                  <v-expansion-panel
                    v-for="(filter, idx) in selectedGptProfile.response_filters"
                    :key="`response-filter-${filter._tmpId || idx}`"
                  >
                    <v-expansion-panel-header>
                      <div class="d-flex align-center w-100 response-filter-header">
                        <template v-if="truncatedFilterTitles[`filter-${idx}`]">
                          <v-tooltip bottom max-width="400">
                            <template v-slot:activator="{ on, attrs }">
                              <span
                                ref="filterTitleRef"
                                v-bind="attrs"
                                v-on="on"
                                class="text-subtitle-1 text-truncate response-filter-title"
                                @mouseenter="checkTextTruncate($event, filter, idx)"
                              >
                                {{ responseFilterPanelTitle(filter, idx) }}
                              </span>
                            </template>
                            <span>{{ responseFilterPanelTitle(filter, idx) }}</span>
                          </v-tooltip>
                        </template>
                        <template v-else>
                          <span
                            ref="filterTitleRef"
                            class="text-subtitle-1 text-truncate response-filter-title"
                            @mouseenter="checkTextTruncate($event, filter, idx)"
                          >
                            {{ responseFilterPanelTitle(filter, idx) }}
                          </span>
                        </template>
                        <v-chip x-small label class="ml-3 flex-shrink-0" :color="filter.type === 'regex' ? 'deep-purple lighten-4' : 'blue-grey lighten-4'">
                          {{ responseFilterTypeLabel(filter.type) }}
                        </v-chip>
                        <v-chip
                          v-if="filter.is_case_sensitive"
                          x-small
                          label
                          class="ml-2 flex-shrink-0"
                          color="amber lighten-4"
                        >
                          {{ $vuetify.lang.t('$vuetify.gpt_profile.response_filters.case_sensitive_chip') }}
                        </v-chip>
                      </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-list dense>
                        <v-list-item>
                          <v-list-item-content class="font-weight-bold">
                            {{ $vuetify.lang.t('$vuetify.gpt_profile.response_filters.pattern_label') }}:
                          </v-list-item-content>
                          <v-list-item-content>
                            {{ filter.pattern || 'N/A' }}
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item>
                          <v-list-item-content class="font-weight-bold">
                            {{ $vuetify.lang.t('$vuetify.gpt_profile.response_filters.type_label') }}:
                          </v-list-item-content>
                          <v-list-item-content>
                            {{ responseFilterTypeLabel(filter.type) }}
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item>
                          <v-list-item-content class="font-weight-bold">
                            {{ $vuetify.lang.t('$vuetify.gpt_profile.response_filters.replace_with_label') }}:
                          </v-list-item-content>
                          <v-list-item-content>
                            {{ filter.replace_with || 'N/A' }}
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item>
                          <v-list-item-content class="font-weight-bold">
                            {{ $vuetify.lang.t('$vuetify.gpt_profile.response_filters.case_sensitive_label') }}:
                          </v-list-item-content>
                          <v-list-item-content>
                            {{ filter.is_case_sensitive ? 'true' : 'false' }}
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
            </v-row>
          </v-list>
          <v-divider></v-divider>
          <v-row class="gpt-profile-actions-row">
            <v-col>
              <v-card-actions class="justify-end">
                <v-btn
                  color="error"
                  outlined
                  text
                  @click="closeProfileDetailModal()"
                >{{$vuetify.lang.t('$vuetify.common.close_btn')}}</v-btn>
              </v-card-actions>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </v-container>
  <!-- </div> -->
</template>

<script>
import { mapState, mapActions } from "vuex";
import {
  SEGMENTS,
  RESPONSE_FILTER_TYPES
} from '@/global/_constants';
import {
  GET_GPT_PROFILES,
  DELETE_GPT_PROFILE,
  UPDATE_GPT_PROFILE_STATE,
  CREATE_GPT_PROFILE,
  ADD_ALERT,
  GET_GPT_PROFILE_BY_ID,
  UPDATE_GPT_PROFILE_API,
  GET_GPT_SETTINGS,
  CREATE_GPT_SETTINGS,
  GET_GPT_MODEL_DETAILS,
  MAIRA_QUESTIONNAIRE,
  FETCH_SHAREABLE_DATA,
  UPDATE_PUBLIC_INVITATION_URL,
  GET_PUBLIC_INVITATIONS_LIST,
} from "@/store/_actiontypes";
import Loader from "@/components/common/loader/Loader";
import { ACTION_BUTTON_GROUP } from "@/components/common/buttongroup/_buttongrouptypes";
import ButtonGroup from "@/components/common/buttongroup/ButtonGroup";
import DialogModal from "@/components/common/DialogModal";
import CreateGptProfile from "@/components/Projects/CreateGptProfile/CreateGptProfile";
import { getTimezoneOffsetLabel } from "@/helpers/timezone";
import { GptProfileMapper } from "@/helpers/dataMappers/gptProfile";
import getEnv from "@/config/env";
import _ from "lodash";

export default {
  mounted() {
    this.getGPTProfiles();
  },
  computed: {
    ...mapState({
      selectedProject: (state) => state.project.selectedProject,
      gptProfiles: (state) => state.project.gptProfiles,
      selectedGptProfile: (state) => state.project.selectedGptProfile,
      gptModelList: (state) => state.project.gptModels,
      profile: (state) => state.project.selectedGptProfile,
      fallbackShareableInfo: state => state.project?.fallbackShareableData ?? {},
      gptModelsDetails: (state) => state.project.gptModelsDetails,
      pageCount(state) {
        if (state.project.gptProfiles.total_hits) {
          const count = Math.ceil(
            state.project.gptProfiles.total_hits / this.itemsPerPage
          );
          return count;
        } else return 1;
      },
    }),
    filteredSearchMode() {
      const searchMode = this.selectedGptProfile.search_mode;
      return searchMode ? searchMode : 'N/A';
    },
    validExternalConfigs() {
      const sanitizedProfile = this.sanitizeRedirectCategories(
        _.cloneDeep(this.selectedGptProfile)
      );

      const arr = sanitizedProfile && Array.isArray(sanitizedProfile.external_system_configs)
        ? sanitizedProfile.external_system_configs
        : [];
      return arr.filter(cfg =>
        cfg &&
        cfg.name &&
        Array.isArray(cfg.shareable_info) &&
        cfg.shareable_info.length
      );
    },
    shareableOptionsMap() {
      return Object.fromEntries(
        (this.fetchedShareableFieldOptions || []).map(it => [String(it.value), it.text])
      );
    },
    liffEndpointURL() {
      return this.selectedGptProfile?.liff_endpoint_url || 'N/A'
    },
    defaultTimezoneLabel() {
      const timezone = this.selectedGptProfile?.time_series_config?.default_timezone;
      if (!timezone) return 'N/A';
      const offset = getTimezoneOffsetLabel(timezone);
      return offset ? `${timezone} (UTC${offset})` : timezone;
    },
    hasTimeSeriesConfig() {
      const config = this.selectedGptProfile?.time_series_config;
      return !!(
        config &&
        (config.require_user_confirmation ||
          config.show_reference_fields ||
          config.default_timezone)
      );
    }
  },
  components: { Loader, ButtonGroup, DialogModal, CreateGptProfile },
  props: {
    tabName: {
      type: String,
      default: null,
    }
  },
  data() {
    return {
      PROJECT_SEGMENTS: SEGMENTS,
      profileEdit: false,
      isLoading: false,
      modelDetailsStatus: "idle",
      openProfileViewModal: false,
      viewProfile: false,
      search: "",
      profileLoading: false,
      itemsPerPage: 10,
      page: 1,
      truncatedFilterTitles: {},
      deleteDialog: false,
      toBeDeletedProfileId: null,
      ACTION_BUTTON_GROUP: ACTION_BUTTON_GROUP,
      rows: [5, 10, 20],
      openCreateProfileModal: false,
      isVisionSupported: false,
      isJsonSupported: false,
      questionnaires: [],
      questionnaireMap: {},
      profileKey: 0,
      frequency_types: {
        max_attempts: this.$vuetify.lang.t("$vuetify.maira_questionnaire.max_attempts") || "Max Attempts",
        retry_interval_days: this.$vuetify.lang.t("$vuetify.maira_questionnaire.retry_interval") || "Retry Interval (Days)",
      },
      headers: [
        {
          text: "Id",
          align: "center",
          value: "id",
          sortable: false,
        },
        {
          text: this.$vuetify.lang.t("$vuetify.table_header.name_header_txt"),
          align: "center",
          value: "name",
          sortable: false,
        },
        {
          text: this.$vuetify.lang.t("$vuetify.gpt_history.gpt_history_model"),
          value: "model",
          align: "center",
          sortable: false,
        },
        {
          text: this.$vuetify.lang.t("$vuetify.table_header.created_at"),
          value: "created_at",
          align: "center",
          sortable: true,
        },
        {
          text: this.$vuetify.lang.t("$vuetify.table_header.actions"),
          value: "actions",
          sortable: false,
          align: "start",
        },
      ],
      actionOptions: [
        { text: "No Action", value: "no_action" },
        { text: "Notification", value: "notification" },
        { text: "Termination", value: "termination" }
      ],
      fetchedShareableFieldOptions: [],
      isLoadingShareable: false,
      pendingInvitationTags: null,
      isGeneratingInvitation: false,
      parentGroupInvitations: [],
      childLiffEnabled: false,
      isDuplicateLoading: false,
    };
  },
  watch: {
    page: {
      handler() {
        const start = (this.page - 1) * this.itemsPerPage;
        const size = this.itemsPerPage;
        this.getGPTProfiles(start, size);
      },
      immediate: false,
    },
    itemsPerPage: {
      handler(newVal) {
        if (this.page === 1) {
          const start = 0;
          const size = newVal;
          this.getGPTProfiles(start, size);
        } else {
          this.page = 1;
        }
      },
      immediate: false,
    },
    tabName: {
      immediate: true,
      handler(newVal) {
        if (newVal === "mairaProfiles") {
          this.getGPTProfiles();
        }
      },
    },
    openProfileViewModal: {
      handler(newVal) {
        if (newVal) {
          // Reset truncation state when modal opens
          this.truncatedFilterTitles = {};
          // Check truncations after DOM updates with a small delay
          this.$nextTick(() => {
            setTimeout(() => {
              this.checkAllFilterTruncations();
            }, 100);
          });
        }
      },
    },
  },
  methods: {
    ...mapActions("project", [
      GET_GPT_PROFILES,
      DELETE_GPT_PROFILE,
      UPDATE_GPT_PROFILE_STATE,
      CREATE_GPT_PROFILE,
      GET_GPT_PROFILE_BY_ID,
      UPDATE_GPT_PROFILE_API,
      GET_GPT_SETTINGS,
      CREATE_GPT_SETTINGS,
      GET_GPT_MODEL_DETAILS,
      MAIRA_QUESTIONNAIRE,
      FETCH_SHAREABLE_DATA
    ]),
    ...mapActions("member", [ UPDATE_PUBLIC_INVITATION_URL, GET_PUBLIC_INVITATIONS_LIST]),

    handleLiffEnabled(isEnabled) {
      this.childLiffEnabled = isEnabled;
    },

    getSeverityLabel(value) {
      if (!value) return value;

      const mapItems = {
        low: this.$vuetify.lang.t('$vuetify.gpt_profile.content_moderation.severity_low_label'),
        medium: this.$vuetify.lang.t('$vuetify.gpt_profile.content_moderation.severity_medium_label'),
        high: this.$vuetify.lang.t('$vuetify.gpt_profile.content_moderation.severity_high_label')
      };

      return mapItems[value.toLowerCase()] || value;
    },

    getSeverityActionLabel(value) {
      const found = this.actionOptions.find(o => o.value === value);
      return found ? found.text : value;
    },

    formatSeverityActions(severityActions) {
      const severityLevels = ['Low', 'Medium', 'High'];

      return severityLevels.map(lvl => {
        const key = lvl.toLowerCase();
        const action = severityActions?.[key] || 'no_action';
        return {
          label: lvl,
          value: this.getSeverityActionLabel(action)
        };
      });
    },


    onDuplicateClick(item) {
      // Deep duplicate to prevent mutating the original profile
      this.profileEdit = false;
      this.profileKey += 1;
      this.openCreateProfileModal = true;
      this.isDuplicateLoading = true;
      this.GET_GPT_PROFILE_BY_ID({
        project_id: this.$route.query.pid,
        profile_id: item.id,
      }).then((res) => {
        const duplicatedProfile = _.cloneDeep(this.selectedGptProfile);
        delete duplicatedProfile.id;

        const duplicateLabel = this.$vuetify.lang.t("$vuetify.common.copy");
        duplicatedProfile.profileName = duplicatedProfile.profileName
          ? `${duplicatedProfile.profileName} (${duplicateLabel})`
          : duplicateLabel;

        this.UPDATE_GPT_PROFILE_STATE({ profile: duplicatedProfile });
        this.isDuplicateLoading = false;
      }).catch((e) => {
        this.isDuplicateLoading = false;
        console.error("Error fetching profile for duplicate:", e);
        this.openCreateProfileModal = false;
        this.$store.dispatch(
          `alert/${ADD_ALERT}`,
          {
            message: this.$vuetify.lang.t("$vuetify.gpt_profile.copy_error_txt"),
            color: "error",
          },
          { root: true }
        );
      });
    },

    closeProfileModal() {
      this.openCreateProfileModal = false;
      this.profileEdit = false;
      this.UPDATE_GPT_PROFILE_STATE({
        profile: GptProfileMapper.mapBackendToFrontend(),
      });
    },
    async getGPTProfiles(start = 0, size = 10) {
      this.isLoading = true;
      this.profileLoading = true;

      return this.GET_GPT_PROFILES({
        project_id: this.$route.query.pid,
        start,
        size,
      }).then(
        (res) => {
          this.isLoading = false;
        },
        (err) => {
          this.isLoading = false;
          console.error("err", err.response);
        }
      );
    },
    deleteItem(item) {
      this.deleteDialog = true;
      this.toBeDeletedProfileId = item.id;
    },
    closeProfileDetailModal() {
      this.viewProfile = false;
      this.openProfileViewModal = false;
      this.UPDATE_GPT_PROFILE_STATE({
        profile: GptProfileMapper.mapBackendToFrontend(),
      });
    },
    onCreateClick() {
      if (this.$refs.profile) {
        this.$refs.profile.resetValidation();
      }
      this.profileEdit = false;
      this.profileKey += 1;
      this.openCreateProfileModal = true;
      // Reset the Vuex `profile` state to default values
      this.UPDATE_GPT_PROFILE_STATE({
        profile: GptProfileMapper.mapBackendToFrontend(),
      });
    },
    onEditClick(item) {
      this.profileEdit = true;
      this.profileLoading = true;
      this.openCreateProfileModal = true;
      this.GET_GPT_PROFILE_BY_ID({
        project_id: this.$route.query.pid,
        profile_id: item.id,
      })
        .then((res) => {
          this.profileLoading = false;
        })
        .catch((e) => {
          this.profileLoading = false;
        });
    },
    async onDetailsClick(item) {
      this.openProfileViewModal = true;
      this.profileLoading = true;
      this.viewProfile = true;

      try {
        await this.GET_GPT_PROFILE_BY_ID({
          project_id: this.$route.query.pid,
          profile_id: item.id,
        });

        await this.fetchQuestionnaires();

        this.profileLoading = false;
        this.gptModelDetails();
        this.viewProfile = false;

        // Check truncation for response filter titles after modal opens
        this.$nextTick(() => {
          this.checkAllFilterTruncations();
        });
      } catch (error) {
        this.viewProfile = false;
        this.profileLoading = false;
      }
    },

    deleteProfile() {
      this.deleteDialog = false;
      this.DELETE_GPT_PROFILE({
        project_id: this.selectedProject.id,
        profile_id: this.toBeDeletedProfileId,
      }).then((res) => {
        this.isLoading = true;
        setTimeout(async () => {
          await this.getGPTProfiles();
          this.isLoading = false;
        }, 2000);
      }).catch((e) => {
        console.error("error", e);
      });
    },
    createProfile() {
      const valid = this.$refs.profile.validateForm();
      if (!valid) {
        this.$store.dispatch(
          `alert/${ADD_ALERT}`,
          {
            message: this.$vuetify.lang.t("$vuetify.gpt_profile.profile_validation_error"),
            color: "red",
          },
          { root: true }
        );
        return;
      }
      this.isLoading = true;
      //adding setTimeout to add includes or excludes unconfirmed chip to be added to the list
      setTimeout(()=> {
        const profilePayload = _.cloneDeep(this.selectedGptProfile);
        delete profilePayload.id;

        this.CREATE_GPT_PROFILE({
        project_id: this.$route.query.pid,
        profile: profilePayload,
      }).then(
        (res) => {
          this.$store.dispatch(
            `alert/${ADD_ALERT}`,
            {
              message: this.$vuetify.lang.t(
                "$vuetify.gpt_profile.profile_creation_success"
              ),
              color: "success",
            },
            { root: true }
          );
          this.updatePublicInvitationIfNeeded();
          // set default profile when creating 1st profile from Personalizer
          if(this.selectedProject.segment.name === this.PROJECT_SEGMENTS.PERSONALIZER){
            this.GET_GPT_SETTINGS({
            project_id: this.$route.query.pid,
          }).then((res2) => {
            if (!res2.data?.detail?.settings) {
              this.CREATE_GPT_SETTINGS({
                project_id: this.$route.query.pid,
                default_profile: res.data?.detail?.profile_id,
              }).then((_res) => {
              }).catch((_err) => {
              });
            }
          });
          }
          this.isLoading = true;
          this.closeProfileModal();
          setTimeout(async () => {
            await this.getGPTProfiles();
            this.isLoading = false;
          }, 2000);
        },
        (err) => {
          console.error("Err", err.response);
          this.isLoading = false;
          this.$store.dispatch(
            `alert/${ADD_ALERT}`,
            {
              message: this.getProfileSaveErrorMessage(err, "create"),
              color: "error",
            },
            { root: true }
          );
        }
      );
      }, 100)
    },
    onGroupInvitationsUpdated(invites) {
      this.parentGroupInvitations = invites;
    },
    onModelStatusChanged (status) {
      this.modelDetailsStatus = status;
    },
    sanitizeLiffConfig(profile) {
      if (!profile.liff_endpoint_url_config) return;

      const cfg = profile.liff_endpoint_url_config;

      if (!cfg.liff_id || String(cfg.liff_id).trim() === '') {
        cfg.group_invitation_token = '';
      }

      const invitations = this.parentGroupInvitations;

      if (!invitations || invitations.length === 0) {
        return profile;
      }

      const token = cfg.group_invitation_token;
      const hasMatchingInvitation = invitations.some(inv => inv.jti === token);

      if (!hasMatchingInvitation) {
        cfg.group_invitation_token = '';
      }

      return profile;
    },
    validateLiffConfig(profile) {
      const cfg = profile?.liff_endpoint_url_config;
      if (!cfg) return true;

      const hasLiffId = cfg.liff_id?.trim();
      const hasGroupToken = cfg.group_invitation_token?.trim();

      if (hasLiffId && !hasGroupToken) {
        return false;
      }

      return true;
    },
    sanitizeRedirectCategories(profile) {
      const moderationCategories =
        profile.content_moderation?.categories?.map(c => c.name) || [];

      profile.external_system_configs?.forEach(config => {
        if (!Array.isArray(config.redirect_triggering_categories)) return;

        config.redirect_triggering_categories =
          config.redirect_triggering_categories.filter(cat =>
            moderationCategories.includes(cat)
          );
      });

      return profile;
    },
    validateRedirectCategories(profile) {
      const configs = profile.external_system_configs || [];
      configs.forEach(cfg => {
        if (!Object.prototype.hasOwnProperty.call(cfg, '_redirectError')) {
          this.$set(cfg, '_redirectError', '');
        } else {
          cfg._redirectError = '';
        }
      });

      const empties = configs
        .map((cfg, i) => {
          const len = Array.isArray(cfg.redirect_triggering_categories)
            ? cfg.redirect_triggering_categories.filter(Boolean).length
            : 0;
          return { idx: i, empty: len === 0 };
        })
        .filter(x => x.empty);

      if (empties.length > 1) {
        empties.slice(1).forEach(e => {
          const message = this.$vuetify.lang.t('$vuetify.gpt_profile.external_system_config.max_one_empty_trigger_allowed');
          this.$set(configs[e.idx], '_redirectError', message);
        });

        const firstEmptyIdx = empties[0].idx;
        this.expandedExternalPanel = firstEmptyIdx;
        this.UPDATE_GPT_PROFILE_STATE({ profile });
        return false;
      }

      this.UPDATE_GPT_PROFILE_STATE({ profile });
      return true;
    },
    triggerRedirectValidationUI(sanitizedProfile) {
      (sanitizedProfile.external_system_configs || []).forEach((cfg, idx) => {
        const refName = `externalRedirect_${idx}`;
        const ref = this.$refs[refName];

        const callOn = (r) => {
          if (!r) return;
          if (typeof r.resetValidation === 'function') {
            try { r.resetValidation(); } catch(e) {
              // ignore
            }
          }
          if (typeof r.validate === 'function') {
            try { r.validate(true); } catch(e) {
              // ignore
            }
          }
        };

        if (Array.isArray(ref)) ref.forEach(callOn);
        else callOn(ref);
      });
    },
    updateProfile() {
      const sanitizedProfile = this.sanitizeRedirectCategories(
        _.cloneDeep(this.selectedGptProfile)
      );
      const redirectOk = this.validateRedirectCategories(sanitizedProfile);

      const sanitizedLiff = this.sanitizeLiffConfig(this.selectedGptProfile);
      const liffOk = this.childLiffEnabled ? this.validateLiffConfig(sanitizedLiff) : true;
      const valid = this.$refs.profile.validateForm();

      if (!valid || !redirectOk || !liffOk) {
        this.$store.dispatch(
          `alert/${ADD_ALERT}`,
          {
            message: this.$vuetify.lang.t("$vuetify.gpt_profile.profile_validation_error"),
            color: "red",
          },
          { root: true }
        );
        if (!redirectOk) {
          this.$nextTick(() => this.triggerRedirectValidationUI(sanitizedProfile));
        }

        return;
      }

      this.isLoading = true;
      //adding setTimeout to add includes or excludes unconfirmed chip to be added to the list
      setTimeout(()=> {
        this.UPDATE_GPT_PROFILE_API({
          project_id: this.$route.query.pid,
          profile: this.selectedGptProfile,
        }).then(
          (res) => {
            this.closeProfileModal();
            setTimeout(async () => {
              await this.getGPTProfiles();
              this.isLoading = false;
            }, 2000);
            this.$store.dispatch(
              `alert/${ADD_ALERT}`,
              {
                message: this.$vuetify.lang.t(
                  "$vuetify.gpt_profile.profile_update_success"
                ),
                color: "success",
              },
              { root: true }
            );
            this.updatePublicInvitationIfNeeded();
          },
          (err) => {
            this.isLoading = false;
            this.$store.dispatch(
              `alert/${ADD_ALERT}`,
              {
                message: this.getProfileSaveErrorMessage(err, "update"),
                color: "error",
              },
              { root: true }
            );
          }
        );
      }, 100)

    },
    getProfileSaveErrorMessage(err, operation = "update") {
      const defaultKey = operation === "create"
        ? "$vuetify.gpt_profile.profile_creation_error"
        : "$vuetify.gpt_profile.profile_update_error";

      const fallback = this.$vuetify.lang.t(defaultKey);

      const responseMsg = err?.response?.data?.detail?.response;
      if (operation === "create" && responseMsg) return responseMsg;

      const detail = err?.response?.data?.detail;
      const msg = Array.isArray(detail) ? detail?.[0]?.msg : null;

      if (!msg) return fallback;
      if (msg.includes("Invalid regex pattern")) {
        return this.$vuetify.lang.t("$vuetify.gpt_profile.response_filters.pattern_invalid_regex_message");
      }
      return msg;
    },
    copyToClipboard(text) {
      navigator.clipboard.writeText(text).then(
        () => {
          this.$store.dispatch(
            `alert/${ADD_ALERT}`,
            {
              message: 'Copied to Clipboard',
              color: 'success',
            },
            { root: true }
          );
        },
        (err) => {
          console.error('Could not copy text: ', err);
        }
      );
    },
    gptModelDetails() {
      return this.GET_GPT_MODEL_DETAILS({
        project_id: this.$route.query.pid,
        provider: this.profile.provider,
        model: this.profile.model,
      }).then(
        (response) => {
          const modelDetails = response.data?.detail?.response;
            this.isVisionSupported = modelDetails.is_vision_supported;
            this.isJsonSupported = modelDetails.is_json_supported;
          this.isLoading = false;
          return modelDetails;
        },
        (err) => {
          this.isLoading = false;
          return null;
        }
      );
    },
    formatLanguages(languages) {
      if (!languages || languages.length === 0) return [];
      const languageMap = {
        en: 'English',
        ja: 'Japanese',
        ko: 'Korean'
      };
      return this.getChipItems(languages, (lang) => languageMap[lang] || lang);
    },
    formatTools(tools) {
      if (!tools || tools.length === 0) return [];
      const toolMap = {
        web_search: this.$vuetify.lang.t('$vuetify.gpt_profile.web_search'),
        code_execution: this.$vuetify.lang.t('$vuetify.gpt_profile.code_execution')
      };
      return this.getChipItems(tools, (tool) => toolMap[tool] || tool);
    },
    responseFilterTypeLabel(type) {
      const key = type === RESPONSE_FILTER_TYPES.REGEX ? 'type_regex_label' : 'type_plain_label';
      return this.$vuetify.lang.t(`$vuetify.gpt_profile.response_filters.${key}`);
    },
    responseFilterPanelTitle(filter, idx) {
      const pattern = String(filter.pattern || '').trim();
      if (!pattern) {
        return `${this.$vuetify.lang.t('$vuetify.gpt_profile.response_filters.filter_label')} ${idx + 1}`;
      }
      const replacement = String(filter.replace_with || '').trim();
      const target = replacement || this.$vuetify.lang.t('$vuetify.gpt_profile.response_filters.removed_label');
      return `${pattern} → ${target}`;
    },
    checkTextTruncate(event, filter, idx) {
      const element = event.target;
      const key = `filter-${idx}`;
      this.$set(this.truncatedFilterTitles, key, element.scrollWidth > element.clientWidth);
    },
    checkAllFilterTruncations() {
      if (!this.selectedGptProfile?.response_filters) return;

      this.$nextTick(() => {
        const refs = this.$refs.filterTitleRef;
        if (!refs) return;

        const refArray = Array.isArray(refs) ? refs : [refs];

        refArray.forEach((element, idx) => {
          if (element) {
            const key = `filter-${idx}`;
            this.$set(this.truncatedFilterTitles, key, element.scrollWidth > element.clientWidth);
          }
        });
      });
    },

    async fetchQuestionnaires() {
      try {
        const { data } = await this.MAIRA_QUESTIONNAIRE({
          project_id: this.$route.query.pid,
          start: 0,
          size: 100,
          active: true
        });

        const list = data?.detail?.response?.questionnaires ?? [];
        // Build both `questionnaires` and `questionnaireMap` in one go
        this.questionnaires = list;
        this.questionnaireMap = Object.fromEntries(
          list.map(q => [q.id, q.name])
        );
      } catch (error) {
        console.error("Error fetching questionnaires:", error);
        this.questionnaires = [];
        this.questionnaireMap = {};
      }
    },

    getQuestionnaireName(id) {
      return this.questionnaireMap?.[id] ?? null;
    },
    getFrequencyLabel(key) {
      return this.frequency_types[key] || this.removeUnderScore(key);
    },
    removeUnderScore(value) {
      if (!value) return "N/A";
      return value
      .toString()
      .replace(/_/g, " ")
      .replace(/\b\w/g, (c) => c.toUpperCase());
    },

    getChipItems(values, mapper = (value) => value) {
      const list = Array.isArray(values) ? values : values !== undefined
        && values !== null && values !== '' ? [values] : [];

      return list.map((value) => mapper(value)).filter((value) => value !== undefined && value !== null && String(value).trim() !== '');
    },

    async fetchShareableFields() {
      this.isLoadingShareable = true;
      try {
        const resp = await this[FETCH_SHAREABLE_DATA]({ project_id: this.$route.query.pid });
        const fieldsFromStore = this.shareableState?.fields;
        const apiFields = fieldsFromStore ?? resp?.data?.detail?.fields ?? {};

        const mapToItems = (fields) => {
          if (fields && typeof fields === 'object' && !Array.isArray(fields)) {
            return Object.entries(fields).map(([key, val]) => ({
              text: String(val),
              value: key
            }));
          }
          return [];
        };
        const items = mapToItems(apiFields);
        this.fetchedShareableFieldOptions = items.length ? items : mapToItems(this.fallbackShareableInfo || {});
      } catch (_err) {
        this.fetchedShareableFieldOptions = Object.keys(this.fallbackShareableInfo || {}).map(k => ({
          text: this.fallbackShareableInfo[k],
          value: k
        }));
      } finally {
        this.isLoadingShareable = false;
      }
    },

    formatShareableInfo(cfg) {
      if (!Array.isArray(cfg.shareable_info) || !cfg.shareable_info.length) return [];
      return this.getChipItems(cfg.shareable_info, (v) => {
        const key = String(v);
        return this.shareableOptionsMap[key] ?? v;
      });
    },
    onProfileTagsChange(payload) {
      if (payload?.invitationId && Array.isArray(payload?.tags)) {
        this.pendingInvitationTags = payload;
      } else {
        this.pendingInvitationTags = null;
      }
    },
    async updatePublicInvitationIfNeeded() {
      if (!this.pendingInvitationTags) return

      const { invitationId, tags } = this.pendingInvitationTags
      if (!invitationId) return

      try {
        const res = await this.UPDATE_PUBLIC_INVITATION_URL({
          projectId: this.$route.query.pid,
          invitationId,
          payload: {
            tags: tags || []
          }
        })
        this.pendingInvitationTags = null
        return res
      } catch (err) {
        console.error("Failed to update invitation tags:", err)
      }
    }
  },
};
</script>


<style scoped>

.chips-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: flex-start;
  padding: 4px 0;
}

.chips-content {
  max-width: 100%;
  height: auto !important;
  border-radius: 12px;
}

.response-filter-title {
  max-width: 60%;
  flex: 0 1 auto;
  min-width: 0;
}

.response-filter-header {
  min-width: 0;
  width: 100%;
}

::v-deep .v-dialog.gpt-profile-dialog:not(.v-dialog--fullscreen) {
  max-width: 87%;
}

::v-deep .v-dialog.gpt-profile-dialog:not(.v-dialog--fullscreen) > .v-card {
  max-height: inherit;
  overflow-y: auto;
  overflow-x: hidden;
}

@media (max-width: 600px) {
  ::v-deep .v-dialog.gpt-profile-dialog:not(.v-dialog--fullscreen) {
    max-width: 100%;
  }

  .response-filter-title {
    max-width: 35%;
  }

  .response-filter-header .v-chip {
    margin-left: 4px !important;
  }

  .response-filter-header .v-btn {
    flex-shrink: 0;
  }
}

.chips-content >>> .v-chip__content {
  white-space: normal;
  word-break: break-word;
  overflow: visible;
  display: block;
  padding: 4px 12px !important;
}

@media (max-width: 532px) {
  .responsive-list-panel .v-list-item__content {
    display: block !important;
    width: 100% !important;
    overflow: visible !important;
    white-space: normal !important;
    word-break: break-word !important;
  }

  .responsive-list-panel .v-list-item__content.align-end {
    text-align: right !important;
  }

  .responsive-list-panel .v-list-item__content > div {
    /* display: block !important; */
    white-space: normal !important;
    word-break: break-word !important;
  }
}

</style>
